import { computed } from 'vue';
import { useDisplay } from 'vuetify';

export function useCardWidth() {
  const { name } = useDisplay();
  return computed(() => {
    switch (name.value) {
      case 'xs':
        return '60vw';
      case 'sm':
        return '65vw';
      case 'md':
        return '70vw';
      case 'lg':
        return '70vw';
      case 'xl':
        return '70vw';
      case 'xxl':
        return '70vw';
      default:
        return undefined;
    }
  });
}

export function useCardLeftMargin() {
  const { name } = useDisplay();
  return computed(() => {
    switch (name.value) {
      case 'xs':
        return '0';
      case 'sm':
        return '0';
      case 'md':
        return '0';
      case 'lg':
        return '5px';
      case 'xl':
        return '5px';
      case 'xxl':
        return '5px';
      default:
        return undefined;
    }
  });
}
